import { gql } from '@apollo/client'
import { mediaUploadFieldsFragment } from 'modules/media-uploads/queries/mediaUploadFields'
import { reviewSummaryFragment } from 'modules/reviews/fragments.graphql'
import { productDropFragment } from 'modules/thingdrops/queries/productDropFragment'

export const getBrandQuery = gql`
  ${reviewSummaryFragment}
  ${mediaUploadFieldsFragment}
  ${productDropFragment}

  fragment DiscountCodeFields on DiscountCode {
    title
    code
    limitToSupertesters
  }

  query GetBrandBySlug($slug: String!) {
    brand(slug: $slug) {
      id
      slug
      title
      titleTag
      rip
      description
      descriptionFromBrand
      primaryImageFullPath
      primaryImageCredit
      secondaryImages {
        ...MediaUploadFields
      }
      assetsFolder
      webUrl
      claimed
      myReview {
        id
      }
      categories {
        id
        name
        slug
        parentId
      }
      demographics
      shipsTo
      status
      hasDiscountCodes
      hasPublicDiscountCodes
      discountCodes {
        ...DiscountCodeFields
      }
      instagramReviewUrl
      shipsTo
      people {
        demographics
        founders {
          name
        }
      }
      company {
        dateFounded
        dateLaunched
        hqLocation
        instagram
        twitter
        linkedinUrl
        facebookUrl
        tiktokUrl
        youtubeUrl
        pintrestUrl
        certificates
      }
      externalLinks {
        storageId
        imageUrl
        title
        url
      }
      milestones {
        type
        completedAt
      }
      reviewSummary {
        ...ReviewSummaryFields
      }
      addedBy {
        id
        username
        fullName
        avatarFullPath
      }

      reviewAiSummary {
        summary
        strengths
        weaknesses
      }

      productDrops(filter: Visible) {
        ...ProductDropFields
      }
    }
  }
`
